import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { notificationEndpoints } from "@/features/notification/api/endpoints";
import type { NotificationPreferenceDto } from "@/features/notification/api/dto";

/**
 * Préférences de notification d'une identité
 * (`GET /NotificationPreferences/party/{partyId}` — guide §6.7). Le service
 * renvoie systématiquement les trois canaux (défaut : activés). Aucun
 * contrôle de rôle côté service (filtré par la policy `GatewayDefault`) —
 * la garde back-office se fait côté page.
 */
export const useNotificationPreferences = (partyId: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.NOTIFICATION_PREFERENCES(partyId),
    queryFn: () =>
      fetchDataGet<NotificationPreferenceDto[]>({
        url: notificationEndpoints.preferences.byParty(partyId),
      }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(partyId),
  });
